import PropTypes from "prop-types";

const OPTIONS = [
  {
    value: 0,
    title: "0: Dislike the hints",
    className: "hint-feedback-option hint-feedback-option--dislike",
    icon: (
      <span className="hint-feedback-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
          <path d="M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z" />
        </svg>
      </span>
    ),
  },
  {
    value: 1,
    title: "1: Hints are just 'OK'",
    className: "hint-feedback-option hint-feedback-option--neutral",
    icon: (
      <span className="hint-feedback-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
          <path d="M4 11h16v2H4z" />
        </svg>
      </span>
    ),
  },
  {
    value: 2,
    title: "2: Pleased with the hints",
    className: "hint-feedback-option hint-feedback-option--pleased",
    icon: (
      <span className="hint-feedback-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
          <path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.58 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z" />
        </svg>
      </span>
    ),
  },
];

export default function HintFeedbackPanel({ onSubmit, isSubmitting, selectedValue }) {
  return (
    <section className="hint-feedback-panel" aria-labelledby="hint-feedback-heading">
      <h4 id="hint-feedback-heading" className="hint-feedback-heading">
        How helpful were the hints for this question?
      </h4>
      <div className="hint-feedback-options" role="group" aria-label="Hint helpfulness">
        {OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            className={`${opt.className}${selectedValue === opt.value ? " hint-feedback-option--selected" : ""}`}
            onClick={() => onSubmit(opt.value)}
            disabled={isSubmitting}
            aria-pressed={selectedValue === opt.value}
            aria-label={opt.title}
          >
            {opt.icon}
            <span className="hint-feedback-label">{opt.title}</span>
          </button>
        ))}
      </div>
    </section>
  );
}

HintFeedbackPanel.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  selectedValue: PropTypes.number,
};
